import { SERVICE_ERROR, SERVICE_EXCEPTION, CLEAR_ALL } from "./ServiceErrorAction";

export const initialState = {
    erorr: ``,
    exception: ``,
}
export const ServiceErrorReducer = (state = initialState, action) => {

    switch (action.type) {
        case SERVICE_ERROR:
            return Object.assign({}, state, {
                error: action.error
            })
        
        case SERVICE_EXCEPTION:
            return Object.assign({}, state, {
                exception: action.exception
            })
        case CLEAR_ALL:
            return Object.assign({}, initialState)
        default:
            return state;
    }
}
export default ServiceErrorReducer;
